export default __webpack_public_path__ + "img/ic-salesperson.26b507dc.svg";